import { render, staticRenderFns } from "./ModalAddUser.vue?vue&type=template&id=05062162&scoped=true&"
import script from "./ModalAddUser.vue?vue&type=script&lang=js&"
export * from "./ModalAddUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddUser.vue?vue&type=style&index=0&id=05062162&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05062162",
  null
  
)

export default component.exports